import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import styled, { css } from 'styled-components'
import { Color, Size } from 'const'
import Alert from 'components/Alert'
import { format } from 'date-fns'

import { usePayHook } from 'hooks'

function Pay() {
  const { payment, isGettingPaymentAPI, getPaymentErrors, setGetPaymentErrors, getPayment } = usePayHook()

  useEffect(() => {
    getPayment()
  }, [getPayment])

  if (isGettingPaymentAPI) {
    return (
      <PayBlock>
        <Caution>お支払い情報の確認中。</Caution>
      </PayBlock>
    )
  } else {
    // APIの設計で、paymentが配列で返ってきてしまう。next_paymentもしくはpayment_historiesがどちらかに何か入ってればactiveとみなす（できればAPIの改善が欲しい）
    const isPaymentActive =
      payment.length > 0 && (payment[0].next_payment.length > 0 || payment[0].payment_histories.length > 0)

    return (
      <React.Fragment>
        {getPaymentErrors.length > 0 && (
          <Alert
            type="error"
            message="エラー"
            description={getPaymentErrors.join('\n')}
            onClose={() => setGetPaymentErrors([])}
          />
        )}
        {isPaymentActive ? (
          <Payment payment={payment}></Payment>
        ) : (
          <PayBlock>
            <Caution>お支払い情報はありません。</Caution>
          </PayBlock>
        )}
      </React.Fragment>
    )
  }
}

function Payment({ payment }) {
  const data = payment[0] // APIの設計で、配列で返ってきてしまうので[0]番目を取得する

  return (
    <PayBlock>
      <NextPayArea>
        <NextPayLabel>次回お支払予定</NextPayLabel>
        <NextPayInfo>
          <NextPayDate>
            {data.next_payment.length > 0 ? format(new Date(data.next_payment[0].billing_date), 'yyyy/MM/dd') : '-'}
          </NextPayDate>
          <NextPayPrice>
            {data.next_payment.length > 0 ? `${Number(data.next_payment[0].amount).toLocaleString()}円` : '-'}
          </NextPayPrice>
        </NextPayInfo>
      </NextPayArea>
      <ListLabel>お支払い履歴</ListLabel>
      <PayList>
        {data.payment_histories.length > 0
          ? _.map(data.payment_histories, (item, idx) => {
              return (
                <PayBox
                  key={idx}
                  date={item.billing_date}
                  amount={item.amount}
                  status={item.status}
                  error_code={item.error_code}
                  message={item.message}
                />
              )
            })
          : '-'}
      </PayList>
    </PayBlock>
  )
}

function PayBox({ date, amount, status, error_code, message }) {
  return (
    <PayArea>
      <PayDate>{date ? format(new Date(date), 'yyyy/MM/dd') : '-'}</PayDate>
      <PayText>{status === 'failure' ? `${error_code} ${message}` : null}</PayText>
      <PayPrice status={status}>{Number(amount).toLocaleString()}円</PayPrice>
    </PayArea>
  )
}

const PayBlock = styled.div`
  padding: 40px 24px;
  border-radius: 10px;
  border: 1px solid ${Color.LINE.NORMAL};
`
const Caution = styled.div``
const NextPayArea = styled.div`
  padding: 15px 0 13px 0;
  border: 1px solid ${Color.LINE.FOOTER};
`
const NextPayLabel = styled.div`
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.BIGGER};
  font-weight: 500;
  padding-bottom: 8px;
  text-align: center;
`
const NextPayInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 100px 80px 1fr;
  grid-template-rows: 30px;
  text-align: center;
`
const NextPayDate = styled.div`
  grid-column: 2;
  color: ${Color.FONT.ANNOTATION};
  font-size: ${Size.FONT.REGULAR};
  display: grid;
  align-items: center;
`
const NextPayPrice = styled.div`
  grid-column: 3;
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.BIG};
  display: grid;
  align-items: center;
`
const ListLabel = styled.div`
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.REGULAR};
  padding: 33px 0 5px 0;
`
const PayList = styled.div``
const PayArea = styled.div`
  display: grid;
  grid-template-columns: 110px 1fr 86px;
  grid-template-rows: 80px;
  border-bottom: 1px solid ${Color.LINE.NORMAL};
`
const PayDate = styled.div`
  color: ${Color.FONT.ANNOTATION};
  font-size: ${Size.FONT.REGULAR};
  grid-column: 1;
  display: grid;
  align-items: center;
`
const PayText = styled.div`
  color: ${Color.FONT.DANGER};
  font-size: ${Size.FONT.REGULAR};
  grid-column: 2;
  display: grid;
  align-items: center;
`
const PayPrice = styled.div`
  ${(props) => css`
    color: ${props.status === 'failure' ? Color.FONT.DANGER : Color.FONT.NORMAL};
    font-size: ${Size.FONT.REGULAR};
    grid-column: 3;
    display: grid;
    align-items: center;
  `}
`

Payment.propTypes = {
  payment: PropTypes.array,
}

PayBox.propTypes = {
  date: PropTypes.string,
  amount: PropTypes.number,
  status: PropTypes.string,
  error_code: PropTypes.string,
  message: PropTypes.string,
}

export default Pay
